import "./insTreeMapChart.scss";
import Highcharts from "highcharts/highstock";
import treeMapModule from "highcharts/modules/treemap";
import React, { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { InsLabelValueTooltip } from "../../base/common/insLabelValueTooltip";
import { InsHighcharts } from "../../base/insHighcharts";
import { treeMapChartDataLabelFormatter } from "./ins-treemap-chart-formatter";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { useSelectedValues, useShownValues, useWidgetComponentProps, useWidgetCurrentDisplayValueType, useWidgetCurrentSortBy } from "components/widgets/hooks/use-current-widget";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { applyUserSettings } from "hooks/widget-data/user-settings/user-settings";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
treeMapModule(Highcharts);
export const InsTreeMapChart = (props) => {
    const { sectionId, widgetId } = props, displayValueType = useWidgetCurrentDisplayValueType(sectionId, widgetId), selectedValues = useSelectedValues(sectionId, widgetId), shownValuesSetting = useShownValues(sectionId, widgetId), sortedBy = useWidgetCurrentSortBy(sectionId, widgetId), widgetProps = useWidgetComponentProps(sectionId, widgetId);
    const [[data], queryState] = useGetDatapointsWidgetData(props), selectedDropDownProps = Object.entries(selectedValues || {}).map(([key, value]) => widgetProps.dataSelectProps[parseInt(key, 10)].selectValues[value]);
    const displayKind = selectedDropDownProps[0]?.valueFormat ?? widgetProps.valueFormat, series = useMemo(() => {
        if (data?.data?.length === 0) {
            return [];
        }
        let [{ series: raw }] = data?.data ?? [{ series: [] }];
        if (raw) {
            raw = applyUserSettings(raw.filter((val) => val.y), { shownValues: shownValuesSetting, sortBy: sortedBy }, widgetProps.colorSet === "esg", "esg-treemap-color", true);
        }
        return raw || [];
    }, [data?.data, shownValuesSetting, sortedBy, widgetProps.colorSet]);
    const { format, sum } = data?.additionalData ?? {};
    const displayFormatKind = displayKind ?? ChartSelectValueFormatKind[format];
    const options = {
        chart: {
            className: "highchart-treemap-widget",
            plotShadow: false,
            style: { fontFamily: "inherit" },
            styledMode: true
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            series: {
                animation: false
            }
        },
        series: [
            {
                colorByPoint: true,
                data: series,
                dataLabels: {
                    allowOverlap: false,
                    formatter() {
                        return treeMapChartDataLabelFormatter(this, displayFormatKind, displayValueType, sum);
                    },
                    useHTML: false
                },
                type: "treemap"
            }
        ],
        // Disable title
        title: undefined,
        tooltip: {
            formatter() {
                return renderToStaticMarkup(React.createElement(InsLabelValueTooltip, { labelValuePairs: this.point.options.custom?.tooltip || [] }));
            }
        }
    };
    return React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState, hasData: Boolean(series?.length) },
        React.createElement(InsHighcharts, { key: `${shownValuesSetting.filter}-${shownValuesSetting.quantity}-${sortedBy}`, options: options, colorSet: widgetProps.colorSet, sectionId: sectionId, widgetId: widgetId, isMaximizedOne: props.isMaximizedOne }));
};
